import ResourceService from './resource.service'

class ServicePointService extends ResourceService {
  static get resource() {
    return 'service-point'
  }

  static inactive(data) {
    return this.put(data, 'inactive')
  }
}

export default ServicePointService
